export default {
  bgImg:
    'https://mylink.oss-accelerate.aliyuncs.com/newMyCity/9.1%E5%9C%B0%E5%9B%BE_TC.png',
  consultation:
    'https://mylink.oss-accelerate.aliyuncs.com/mycity/banner/activity_sc.png ',
  cityImg:
    ' https://mylink.oss-accelerate.aliyuncs.com/mycity/%E5%9F%8E%E5%B8%82%E5%9C%B0%E5%9B%BE.png',
  mapImg:
    'https://mylink.oss-accelerate.aliyuncs.com/newMyCity/9.0.1/9.1%E5%9C%B0%E5%9B%BE_%E7%BC%A9%E7%95%A5%E5%9B%BE_TC.png',
  title1: '城市地圖',
  title2: '個人之家',
  title3: '返回首頁',
  title4: ' My功能',
  title5: '全部',
  title6: '城市地圖',
  c1: '拖動頁面查看更多建築 , 精彩City等你慢慢逛',
  c2: '展開即可快速流覽尋找您想要的功能服務',
  c3: '打開CityMap , 可以知道您當前位置,還能快速抵達你想去的地方',
  c4: '點擊氣泡或建築 , 將進入對應功能服務頁面',
  c5: '下一步',
  c6: '我知道了',
  c7: '跳過',
  c8: ' 按此下拉返回',
  c9: '即將開放，敬請期待！'
}
